// eslint-disable-next-line import/no-cycle
import AuthService from "../../AuthService";

const membershipBenefit = {
  getMembershipBenefit(page) {
    return AuthService.get(`/membership/membership_benefits?page=${page}`);
  },
  showMembershipBenefit(id) {
    return AuthService.get(`/membership/membership_benefits/${id}`);
  },
  createMembershipBenefit(data) {
    return AuthService.post("/membership/membership_benefits", data);
  },
  updateMembershipBenefit(id, data) {
    return AuthService.put(`/membership/membership_benefits/${id}`, data);
  },
  deleteMembershipBenefit(id) {
    return AuthService.delete(`/membership/membership_benefits/${id}`);
  }
};
export default membershipBenefit;
